import { QueryCache, QueryClient } from '@tanstack/react-query'
import { axiosInstance, axiosNextJSInstance } from './axios'

// La cache deve essere unica per permettere ai due client di vedere gli stessi dati
const sharedQueryCache = new QueryCache()

export const queryClient = new QueryClient({
  queryCache: sharedQueryCache,
  defaultOptions: {
    queries: {
      queryFn: async ({ queryKey }) => {
        const { data } = await axiosInstance.get(queryKey[0] as string)
        return data
      },

      refetchOnReconnect(query) {
        if (query.state.status === `pending`) {
          return true
        }
        return false
      }
    }
  }
})

export const queryClientNextJS = new QueryClient({
  queryCache: sharedQueryCache,
  defaultOptions: {
    queries: {
      queryFn: async ({ queryKey }) => {
        const { data } = await axiosNextJSInstance.get(queryKey[0] as string)
        return data
      },
      refetchOnReconnect(query) {
        if (query.state.status === 'pending') {
          return true
        }
        return false
      }
    }
  }
})
